module.exports = __webpack_public_path__ + "img/tiger.9183c0ed.svg";